// extracted by mini-css-extract-plugin
export default {"container":"CheckoutFeedbackChunk_container__GZ1mZ"};